import { GovernancePanel } from '@/components/governance/GovernancePanel';
import { useFinancePnlCommunityPicker, useFinancePnlGovernance, useSaveFinancePnlGovernance } from '@/hooks/useBudgetControl';

/**
 * Permisos de Control Presupuestario: Juan Cruz (admin fijo) elige quién ve el
 * dashboard y quién puede preguntarle al Brain sobre Finance, por persona o
 * por team/área del community map.
 */
export function FinancePnlGovernanceTab() {
  const { data: governance, isLoading, isError } = useFinancePnlGovernance();
  const { data: members = [], isLoading: membersLoading } = useFinancePnlCommunityPicker();
  const save = useSaveFinancePnlGovernance();
  return (
    <GovernancePanel
      namespace="budget_control.governance"
      governance={governance}
      isLoading={isLoading}
      isError={isError}
      members={members}
      membersLoading={membersLoading}
      onSave={(payload, onSuccess) => save.mutate(payload, { onSuccess })}
      saving={save.isPending}
    />
  );
}
